<template>
  <div>
    <PCNavbar :selectIndex="0" />
    <MobileNavBar :currentActive="0" />
    <CarouselHome />
    <HotProducts />
    <HomeAboutUs />
    <div class="bottom_circle" v-if="hidden">
      <h1 class="bottom_circle_title">{{ title }}</h1>
      <div class="circle_img">
        <img :src="img" alt="" class="hidden-xs-only" />
        <img :src="img" alt="" class="hidden-sm-and-up" />
      </div>
    </div>
    <MainProducts />
    <ProductCategory />
    <OurAdvantage />
    <NewsInfomation />
    <ExhibitionPreView />
    <SubscribeUs />
    <CallMe />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome from '@/components/carousel_home/index'
import ProductCategory from '@/components/product_category/index'
import HotProducts from '@/components/hot_products/index'
import MainProducts from '@/components/main_products/index'
import HomeAboutUs from '@/components/home_aboutUs/index'
import OurAdvantage from '@/components/our_advantage/index'
import NewsInfomation from '@/components/news_infomation/index'
import ExhibitionPreView from '@/components/exhibition_preview/index'
import SubscribeUs from '@/components/subscribe_us/index'
import CallMe from '@/components/callme/index'
import Constant from '../utils/Constant'
import { leftLikeDict } from '../api/system'
import { findDictHidden, findMainProp } from '../utils'
import ScrollReveal from 'scrollreveal'

export default {
  data() {
    return {
      img: '',
      title: '',
      hidden: true
    }
  },
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    HotProducts,
    HomeAboutUs,
    MainProducts,
    ProductCategory,
    OurAdvantage,
    NewsInfomation,
    ExhibitionPreView,
    SubscribeUs,
    CallMe
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.HOME3);
      if (res.data) {
        const { title, content } = findMainProp(res.data.data, Constant.HOME3)
        this.img = content
        this.title = title
        this.hidden = findDictHidden(Constant.HOME3, res.data.data)
      }
      this.$nextTick(() => {
        ['.bottom_circle_title', '.circle_img'].forEach(v => {
          ScrollReveal().reveal(v, {
            distance: '10px',
            duration: 800,
            interval: 100,
            origin: 'bottom',
            reset: false,
            viewFactor: 0.6
          })
        })
      })
    }
  },
  mounted() {
    this.leftLikeDictFunc()
  }
}
</script>

<style lang="scss" scoped>
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png), url(../assets/img/smalldot1.png);
  background-position: 0 0, 110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;

  h1 {
    font-size: 40px;
    padding-bottom: 20px;

    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }

  .circle_img {
    width: 100%;

    img {
      width: 70%;

      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }
}
</style>